import { useState, useRef, useEffect, useCallback } from 'react'

/**
 * Reusable DropdownMenu with glass-panel styling.
 * Desktop: hover to open. Mobile: tap trigger to toggle, tap option / outside to close.
 */
export const DropdownMenu = ({ trigger, children, disabled }) => {
    const [open, setOpen] = useState(false)
    const containerRef = useRef(null)

    const close = useCallback(() => setOpen(false), [])

    const toggle = useCallback((e) => {
        if (disabled) return
        const menu = containerRef.current?.querySelector('.dropdown-menu')
        if (menu?.contains(e.target)) {
            close()
            return
        }
        setOpen(prev => !prev)
    }, [disabled, close])

    useEffect(() => {
        if (!open) return
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                close()
            }
        }
        document.addEventListener('click', handleClickOutside)
        return () => document.removeEventListener('click', handleClickOutside)
    }, [open, close])

    return (
        <div
            ref={containerRef}
            className={`dropdown-menu-container${disabled ? ' disabled' : ''}${open ? ' open' : ''}`}
            onClick={toggle}
        >
            {trigger}
            <div className="dropdown-menu below">{children}</div>
        </div>
    )
};
